// import React from 'react'
// import "./TermsContainer.css"
// function TermsContainer({layout}) {
//   return (
//     <section className='terms_container'>
// {layout&&layout.TermsContainer}
//     </section>
//   )
// }

// export default TermsContainer
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

/**
 * TermsContainer.jsx
 * A single-file React component (Tailwind CSS classes) that displays
 * bilingual (Arabic + English) Terms & Conditions and provides
 * copy-to-clipboard buttons which copy each language as a single
 * continuous block of text (no extra blank lines), ready to paste.
 *
 * Props:
 *  - storeName, domain, email, companyAddress, effectiveDate
 *
 * Usage:
 *  <TermsContainer
 *    storeName="My Store"
 *    domain="mystore.com"
 *    email="info@mystore.com"
 *    companyAddress="Cairo, Egypt"
 *    effectiveDate="2025-10-09"
 *  />
 */

const defaultArabic = `الشروط والأحكام
من خلال دخولك إلى موقعنا الإلكتروني  أو استخدامك لخدماتنا، فإنك توافق على الالتزام بهذه الشروط والأحكام. يرجى قراءة هذه الشروط بعناية قبل استخدام الموقع.
باستخدامك للموقع، فإنك تؤكد أنك تبلغ السن القانوني وأنك توافق على الالتزام بكل ما ورد في هذه الشروط. إذا كنت لا توافق على أي من هذه البنود، يُرجى عدم استخدام الموقع.
1. استخدام الموقع
يُسمح لك باستخدام الموقع لأغراض قانونية فقط وبطريقة لا تنتهك حقوق الآخرين أو تقيّد استخدامهم للموقع. لا يجوز لك استخدام الموقع لأي نشاط غير قانوني أو احتيالي أو يسبب ضرراً للموقع أو لمستخدميه.
2. حساب المستخدم
عند إنشاء حساب على موقعنا، يجب أن تقدم معلومات صحيحة وكاملة. تتحمل مسؤولية الحفاظ على سرية بيانات تسجيل الدخول الخاصة بك، وأي نشاط يتم عبر حسابك هو تحت مسؤوليتك الشخصية.
3. المنتجات والأسعار
نحن نسعى لتقديم معلومات دقيقة عن منتجاتنا وأسعارها، ولكن قد تحدث أخطاء في بعض الأحيان. نحتفظ بالحق في تصحيح أي خطأ في الأسعار أو المعلومات قبل أو بعد تأكيد الطلب.
4. الدفع والطلبات
يجب دفع قيمة الطلبات عبر وسائل الدفع المتاحة على الموقع. نحتفظ بالحق في رفض أو إلغاء أي طلب في حال الاشتباه بوجود نشاط احتيالي أو مخالف للشروط.
5. الشحن والتوصيل
نلتزم بتوصيل الطلبات في الوقت المحدد قدر الإمكان، ولكن قد تحدث تأخيرات خارجة عن إرادتنا. لا نتحمل مسؤولية أي تأخير ناتج عن ظروف قاهرة أو أسباب خارجة عن السيطرة.
6. الإرجاع والاستبدال
تُطبق سياسة الإرجاع أو الاستبدال الخاصة بنا حسب الشروط المذكورة في صفحة "سياسة الإرجاع". يجب على العميل مراجعتها قبل الشراء.
7. حقوق الملكية الفكرية
جميع المحتويات في هذا الموقع بما في ذلك النصوص والصور والشعارات والرموز مملوكة لـ [اسم متجرك] ومحمية بموجب قوانين حقوق النشر والعلامات التجارية. يُحظر نسخ أو استخدام أي محتوى بدون إذن خطي مسبق.
8. تحديد المسؤولية
نحن غير مسؤولين عن أي أضرار مباشرة أو غير مباشرة تنشأ نتيجة استخدام الموقع أو الخدمات أو المنتجات. استخدامك للموقع يكون على مسؤوليتك الخاصة.
9. التعديلات على الشروط
نحتفظ بالحق في تعديل هذه الشروط في أي وقت دون إشعار مسبق. استمرارك في استخدام الموقع بعد نشر التعديلات يعني موافقتك عليها.
10. القانون الحاكم
تخضع هذه الشروط والأحكام لقوانين مصر، وأي نزاع يتم حله أمام المحاكم المختصة في الاسماعلية.
11. الاتصال بنا
إذا كانت لديك أي أسئلة بخصوص هذه الشروط والأحكام، يمكنك التواصل معنا عبر البريد الإلكتروني: support@smileheavenglow.com.`;

const defaultEnglish = `Terms and Conditions
 By accessing our website or using our services, you agree to comply with and be bound by these Terms and Conditions. Please read them carefully before using our website.
By using this website, you confirm that you are of legal age and that you agree to these terms in full. If you do not agree with any part of these terms, please do not use our site.
1. Use of the Website
You may use this website for lawful purposes only. You agree not to use the website in a way that violates the rights of others, restricts their use, or causes harm to the website or its users.
2. User Account
When creating an account, you must provide accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials and all activities under your account.
3. Products and Pricing
We strive to provide accurate product information and pricing, but errors may occur. We reserve the right to correct any errors before or after an order is confirmed.
4. Payments and Orders
Payments must be made using the payment methods available on the site. We reserve the right to refuse or cancel any order if we suspect fraud or a violation of these terms.
5. Shipping and Delivery
We aim to deliver your orders on time, but delays may occur due to factors beyond our control. We are not responsible for any delay caused by unforeseen circumstances.
6. Returns and Exchanges
Our return and exchange policy applies as stated on the "Return Policy" page. Customers should review it before making a purchase.
7. Intellectual Property Rights
All content on this website, including text, images, logos, and icons, is owned by [Your Store Name] and protected under copyright and trademark laws. You may not copy, reproduce, or use any content without prior written permission.
8. Limitation of Liability
We are not liable for any direct or indirect damages resulting from the use of our website, services, or products. Your use of the website is at your own risk.
9. Changes to Terms
We reserve the right to modify these terms at any time without prior notice. Continued use of the website after changes are posted constitutes your acceptance of the revised terms.
10. Governing Law
These Terms and Conditions are governed by the laws of Egypt, and any disputes shall be subject to the exclusive jurisdiction of the courts ofIsmalia
11. Contact Us
If you have any questions regarding these Terms and Conditions, please contact us at support@smileheavenglow.com

.`;

export default function TermsContainer({
  storeName = "[Your Store Name]",
  domain = "[yourdomain.com]",
  email = "[your email address]",
  companyAddress = "[your company address]",
  effectiveDate = "[Insert Date]",
}) {
    const { currentLocal } = useSelector((state) => state.currentLocal);

  const [lang, setLang] = useState(currentLocal.language==="English"?'en':"ar"); // 'ar' | 'en' | 'both'
useEffect(() => {
setLang(currentLocal.language==="English"?'en':"ar")
}, [currentLocal])
  const buildArabic = () => {
    // replace placeholders
    return defaultArabic
      .replace(/\[اسم متجرك\]/g, storeName)
      .replace(/\[yourdomain.com\]/g, domain)
      .replace(/\[your email address\]/g, email)
      .replace(/\[أدخل التاريخ\]/g, effectiveDate)
      .replace(/\[اسم الدولة\]/g, "Egypt")
      .replace(/\[اسم المدينة أو الدولة\]/g, "[Your City or Country]");
  };

  const buildEnglish = () => {
    return defaultEnglish
      .replace(/\[Your Store Name\]/g, storeName)
      .replace(/\[yourdomain.com\]/g, domain)
      .replace(/\[your email address\]/g, email)
      .replace(/\[Insert Date\]/g, effectiveDate)
      .replace(/\[Your Country\]/g, "Egypt")
      .replace(/\[Your City or Country\]/g, "[Your City or Country]");
  };



  return (
    <div className="max-w-5xl mx-auto p-6">
      <header className="flex items-center justify-between mb-6">
        <div className="flex gap-2">
        
  

        </div>
      </header>

      <div className="flex gap-6 flex-col lg:flex-row">
        {(lang === "both" || lang === "ar") && (
          <section className="flex-1 p-4 border rounded" dir="rtl">
    
            <div className="prose prose-lg overflow-auto max-h-[60vh]">
              {/* Render Arabic as paragraphs */}
              {buildArabic().split(/\n/).map((line, i) => (
                <p key={i} style={{marginTop: i===0?0:8}}>{line}</p>
              ))}
            </div>
          </section>
        )}

        {(lang === "both" || lang === "en") && (
          <section className="flex-1 p-4 border rounded">
  

            <div className="prose prose-lg overflow-auto max-h-[60vh]">
              {buildEnglish().split(/\n/).map((line, i) => (
                <p key={i} style={{marginTop: i===0?0:8}}>{line}</p>
              ))}
            </div>
          </section>
        )}
      </div>


    </div>
  );
}
